class CollectionBanner {
  constructor() {
    this.init();
  }

  init() {
    const wrapper = document.querySelector('[data-description-wrapper]');
    if (!wrapper) return;

    const description = wrapper.querySelector('[data-description]');
    const button = wrapper.querySelector('[data-read-more-button]');
    const readMoreText = wrapper.querySelector('[data-read-more-text]');
    const readLessText = wrapper.querySelector('[data-read-less-text]');

    if (!description || !button || !readMoreText || !readLessText) return;

    // Get the full height of the description
    const collapsedHeight = 150; // Match CSS max-height
    
    // Temporarily set to auto to measure full height
    const originalMaxHeight = description.style.maxHeight;
    description.style.maxHeight = 'none';
    const fullHeight = description.scrollHeight;
    description.style.maxHeight = originalMaxHeight || '';

    // Only show button if content is taller than collapsed height
    if (fullHeight <= collapsedHeight) {
      button.style.display = 'none';
      return;
    }

    // Set initial collapsed state
    description.setAttribute('data-collapsed', 'true');
    description.style.maxHeight = `${collapsedHeight}px`;

    // Handle button click
    button.addEventListener('click', () => {
      const isCollapsed = description.getAttribute('data-collapsed') === 'true';

      if (isCollapsed) {
        // Expand
        description.setAttribute('data-collapsed', 'false');
        // Use a large value for max-height to allow smooth expansion
        description.style.maxHeight = `${fullHeight + 100}px`;
        readMoreText.style.display = 'none';
        readLessText.style.display = '';
      } else {
        // Collapse
        description.setAttribute('data-collapsed', 'true');
        description.style.maxHeight = `${collapsedHeight}px`;
        readMoreText.style.display = '';
        readLessText.style.display = 'none';
        
        // Smooth scroll to top of description
        setTimeout(() => {
          description.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
      }
    });

    // Update on resize in case content changes
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Re-measure full height
        const originalMaxHeight = description.style.maxHeight;
        description.style.maxHeight = 'none';
        const newHeight = description.scrollHeight;
        description.style.maxHeight = originalMaxHeight || '';
        
        if (description.getAttribute('data-collapsed') === 'false') {
          description.style.maxHeight = `${newHeight + 100}px`;
        }
      }, 250);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionBanner();
  });
} else {
  new CollectionBanner();
}

